// extracted by mini-css-extract-plugin
export default {"projectForm":"style_projectForm__B+ISZ","button":"style_button__C1Mod"};